import React from 'react';
import PropTypes from 'prop-types';
import { C, Masks, Sum } from 'shared/helpers';

import Styles from './Table.module.scss';

import NumberFormat from 'react-number-format';

export default function Table({
  productivityPerHa,
  productionUnit,
  totals,
  perguntas,
  edit,
  form,
  setForm,
}) {
  const { Table, Row, Block, First, Final, Total } = Styles;

  const { currency, number } = Masks;

  let divCount = 0;
  const k = () => `key${++divCount}`;

  const sqmvTotal = Sum((totals || []).map(x => x[0]));

  const PercentTotal = perguntas.map(({ id }) => (form[id] / sqmvTotal) * 100);
  const WeightTotal = perguntas.map(({ id }) => form[id] / productivityPerHa);
  const UNIT = productionUnit || 'kg';

  return (
    <div className={Table}>
      <header>
        <div className={First}>
          ITENS DE ECONOMIAS INDIRETAS SOBRE O CUSTO TOTAL DA RECOMENDAÇÃO DA
          SQM VITAS BRASIL
        </div>
        <div>Economia Indireta em R$/ha</div>
        <div>Economia Indireta em % sobre custo manejo nutricional</div>
        <div>Economia Indireta em {`${UNIT}`} da lavoura</div>
      </header>
      <main>
        {perguntas.map(({ pergunta, id }, index) => (
          <div key={k()} className={C(Row)}>
            <div className={C(Block, First)} id={`pergunta_${index}_pergunta`}>
              {pergunta}
            </div>
            <div
              className={C(Block, [index === 7, Final])}
              id={edit ? '' : `pergunta_${index}_valor`}
            >
              {!edit ? (
                currency(form[id] || 0, { suffix: ' /ha' })
              ) : (
                <NumberFormat
                  allowEmptyFormatting
                  id={`pergunta_${index}_valor`}
                  prefix={'R$ '}
                  suffix={' /ha'}
                  onValueChange={({ value }) =>
                    setForm(form => ({ ...form, [id]: value }))
                  }
                  defaultValue={form[id] ? Number(form[id]) : ''}
                  thousandSeparator={'.'}
                  decimalSeparator={','}
                  decimalScale='2'
                  fixedDecimalScale='2'
                />
                )}
            </div>
            <div
              className={C(Block, index === 7 && Final)}
              id={`pergunta_${index}_percent`}
            >
              {number((form[id] / sqmvTotal) * 100, { suffix: ' %' })}
            </div>
            <div
              className={C(Block, index === 7 && Final)}
              id={`pergunta_${index}_production_unit`}
            >
              {number(form[id] / productivityPerHa, {
                mind: 2,
                maxd: 2,
                suffix: productionUnit,
              })}
            </div>
          </div>
        ))}
        <div className={C(Row, Total)}>
          <div className={C(Block, First)}>TOTAL</div>
          <div className={C(Block)} id={'perguntas_total'}>
            {currency(Sum(Object.values(form)))}
          </div>
          <div className={C(Block)} id={'perguntas_percent_total'}>
            {number(PercentTotal, { suffix: ' %' })}
          </div>
          <div className={C(Block)} id={'perguntas_production_total'}>
            {number(WeightTotal, { mind: 2, maxd: 2, suffix: productionUnit })}
          </div>
        </div>
      </main>
    </div>
  );
}

Table.defaultProps = {
  edit: false,
  totals: [0],
  productivityPerHa: 0,
  productionUnit: 'kg',
};

Table.propTypes = {
  perguntas: PropTypes.array.isRequired,
  edit: PropTypes.bool,
  form: PropTypes.any.isRequired,
  setForm: PropTypes.func.isRequired,
  totals: PropTypes.array,
  productivityPerHa: PropTypes.number,
  productionUnit: PropTypes.string,
};
